import { Button } from '@/ui/@components/primitives/button';
import { APP_ROUTES } from '@/ui/app-routes';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8'>
      <div className='mx-auto text-center'>
        <h1 className='text-6xl font-bold tracking-tight text-primary'>
          {t('notFound.title', '404')}
        </h1>
        <h2 className='mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl'>
          {t('notFound.subtitle', 'Page not found')}
        </h2>
        <p className='mt-4 text-muted-foreground max-w-md mx-auto'>
          {t(
            'notFound.description',
            "Sorry, we couldn't find the page you're looking for."
          )}
        </p>
        <div className='mt-8'>
          <Button onClick={() => navigate(APP_ROUTES.ROOT)} variant='default'>
            {t('notFound.backToDashboard', 'Back to Dashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
}
